import {map} from 'rxjs/operators';

import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-lenderleftdiv',
    templateUrl: './lenderleftdiv.component.html',
    styleUrls: ['./lenderleftdiv.component.css'],
    providers: [ApiServiceService]
})
export class LenderleftdivComponent implements OnInit {

    result2: any;
    lender_application_complete: number;
    lender_application: number;
    bank_details_filled: any;
    nominee_details_filled: any;
    investment_preferences: any;
    private readonly storageService: StorageService;

    constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private ref: ApiServiceService, storageService: StorageService) {
        this.storageService = storageService;
    }

    ngOnInit() {
        if (!this.storageService.getItem(Keys.LENDER_ID)) {
            if (this.storageService.getObjectFromSession(Keys.PHONE_VERIFICATION_REQUEST_TOKEN)) {
                this.lender_application = 2;
            } else {
                this.lender_application = 1;
            }
        } else {
            this.result2 = this.http.post<any>(this.ref.baseURL() + 'getLenderInfoDetails',
                {
                    lender_id: this.storageService.getItem(Keys.LENDER_ID),
                    profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                    token: this.storageService.getItem(Keys.TOKEN)
                }).subscribe((result2) => {
                    this.result2 = result2;
                    if ((!this.result2.lender_info.profile.email)) {
                        this.lender_application = 3;
                        return;
                    } else if (this.result2.status === 'success') {
                        this.lender_application_complete = this.result2.lender_info.lender_application_complete;
                        this.bank_details_filled = this.result2.lender_info.bank_account !== undefined;
                    }
                });
            this.nominee_details_filled = !!this.storageService.getItem(Keys.LENDER_NOMINEE);
            this.investment_preferences = !!this.storageService.getItem(Keys.INVESTMENT_PREFERENCES);
        }
    }
}
